import LoadingSpinner from '../components/LoadingSpinner.js'
import UniverseList from '../components/UniverseList.js';
export default class UniversesPage{
    constructor(app, params){
        this.app = app;
        this.params = params;
    }

    async mount(container) {
        this.container = container;
        this.render();
    }

    render(){
        this.container. innerHTML = `
            <div id="universe-page">
                <div id="loading"></div>
                <div id="universe-list"></div>
            </div>
        `;
        this.renderUniverseList();
    }

    async renderUniverseList(){

        // this.app.pathStory.push('/');
        
        const clickHandler = (id)=> {
            this.app.api.universeID = id;
            this.app.router.navigate(`/heroes`);
        }

        // const initData = await this.app.api.sendInitData();
        // console.log('init data:', initData);

        const universeList = this.container.querySelector('#universe-list');
        const universesJSON = await this.app.api.getAllUniverses();
        const universeListComponent = new UniverseList({
            universes: universesJSON,
            clickHandler: clickHandler
        });
        universeListComponent.render(universeList);
    }

}